import { ClassValue } from 'clsx';
import { isString } from 'lodash';
import { ReactNode } from 'react';
import { Text, TextProps } from '@shared/components/Text';
import { View } from '@shared/components/View';
import styles from './MenuTitleBar.module.css';

interface MenuTitleBarProps {
  title?: ReactNode;
  titleProps?: TextProps;
  showBorder?: boolean;
  startContent?: ReactNode;
  endContent?: ReactNode;
  className?: ClassValue;
  mobileOnly?: boolean;
}

/**
 * Menu.TitleBar
 *
 * A three-column bar for the top of `Menu.Content`: start content, a centered
 * title, and end content. Start and end are empty unless the caller fills
 * them, typically with `Menu.BackButton` and `Menu.CloseButton`. Search, tabs
 * and other controls go below the bar as regular content.
 */

export function MenuTitleBar({
  title,
  titleProps,
  showBorder = true,
  startContent,
  endContent,
  className,
  mobileOnly = false,
}: MenuTitleBarProps) {
  return (
    <View
      className={[
        styles.titleBar,
        showBorder && styles.bordered,
        mobileOnly && styles.mobileOnly,
        className,
      ]}
    >
      <div className={styles.start}>{startContent}</div>
      <div className={styles.title}>
        {isString(title) && (
          <Text size="subtitle" weight="semibold" numberOfLines={1} {...titleProps}>
            {title}
          </Text>
        )}
        {!isString(title) && title}
      </div>
      <div className={styles.end}>{endContent}</div>
    </View>
  );
}
